(function () {
  "use strict";

  var SPINNER_HTML =
    '<span class="product-buy-buttons--spinner" aria-hidden="true">' +
    '<svg class="icon--root icon--spinner"><use href="#loading-spinner" xlink:href="#loading-spinner"></use></svg>' +
    "</span>";

  function isMiniCartEnabled() {
    return !!document.querySelector('[data-lp-mini-cart="true"]');
  }

  function cartBase() {
    if (typeof theme !== "undefined" && theme.urls && theme.urls.cart) {
      return String(theme.urls.cart).replace(/\/$/, "");
    }
    return "/cart";
  }

  function applyDiscount(code) {
    if (!code) return Promise.resolve(true);
    return fetch("/discount/" + encodeURIComponent(code), {
      credentials: "same-origin",
    })
      .then(function (r) {
        return r.ok;
      })
      .catch(function () {
        return false;
      });
  }

  function addItems(items) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials: "same-origin",
      body: JSON.stringify({ items: items }),
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) {
          throw new Error(
            (data && (data.description || data.message)) || "cart add failed",
          );
        }
        return data;
      });
    });
  }

  function syncCartCounts(count) {
    if (typeof count !== "number") return;
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.setAttribute("data-cart-count", String(count));
    });
  }

  function syncCountsFromBasket() {
    if (typeof theme === "undefined" || !theme.cart || !theme.cart.basket)
      return;
    var count = 0;
    var basket = theme.cart.basket;
    Object.keys(basket).forEach(function (id) {
      count += parseInt(basket[id], 10) || 0;
    });
    syncCartCounts(count);
  }

  function openDrawer() {
    if (
      typeof theme !== "undefined" &&
      theme.settings &&
      theme.settings.cart_type === "drawer" &&
      theme.drawer &&
      typeof theme.drawer.open === "function"
    ) {
      theme.drawer.open("right", "cart-drawer");
    }
  }

  function refreshCartInBackground(cartResponse) {
    if (typeof theme === "undefined" || !theme.cart) return Promise.resolve();
    return theme.cart
      .fetchTotals()
      .then(function () {
        syncCountsFromBasket();
        if (typeof window.trigger === "function") {
          window.trigger("theme:cart:productAdded", { detail: cartResponse });
        }
      })
      .then(function () {
        return theme.cart.updateAllHtml(true);
      })
      .catch(function () {});
  }

  function ensureSpinner(button) {
    if (!button) return;
    button.classList.add("lp-cart-atc");
    if (button.querySelector(".product-buy-buttons--spinner")) return;
    if (
      !button.querySelector(
        ".lp-editorial-btn__label, .product-buy-buttons--cta-text",
      )
    ) {
      var label = document.createElement("span");
      label.className = "lp-editorial-btn__label";
      while (button.firstChild) {
        label.appendChild(button.firstChild);
      }
      button.appendChild(label);
    }
    button.insertAdjacentHTML("beforeend", SPINNER_HTML);
  }

  function clearSpinner(button) {
    if (!button) return;
    button
      .querySelectorAll(".product-buy-buttons--spinner[aria-hidden='true']")
      .forEach(function (el) {
        // Keep the Liquid-rendered spinner; only remove injected copies.
        if (el.getAttribute("data-lp-injected") === "true") el.remove();
      });
  }

  function setBusy(button, isBusy) {
    if (!button) return;
    if (isBusy) {
      ensureSpinner(button);
      var injected = button.querySelector(
        ".product-buy-buttons--spinner:last-child",
      );
      if (injected) injected.setAttribute("data-lp-injected", "true");
      button.setAttribute("aria-busy", "true");
      button.setAttribute("data-lp-cart-busy", "true");
      if ("disabled" in button) button.disabled = true;
      return;
    }
    clearSpinner(button);
    button.setAttribute("aria-busy", "false");
    button.removeAttribute("data-lp-cart-busy");
    if ("disabled" in button) button.disabled = false;
  }

  function getForm(root) {
    return (
      root.closest("form[data-lp-ritual-form]") ||
      root.closest("form.product-page--form") ||
      root.closest("form")
    );
  }

  function getSellingPlanId(form) {
    if (!form) return null;
    var input =
      form.querySelector('input[type="radio"][name="selling_plan"]:checked') ||
      form.querySelector('select[name="selling_plan"]:not([disabled])') ||
      form.querySelector('input[type="hidden"][name="selling_plan"]') ||
      form.querySelector('input[name="selling_plan"]:not([type="radio"])');
    if (!input) return null;
    var value = String(input.value || "").trim();
    if (!value || value === "0") return null;
    var parsed = parseInt(value, 10);
    return parsed > 0 ? parsed : null;
  }

  function buildItems(root) {
    var selected = root.querySelector("[data-lp-ritual-variant]:checked");
    if (!selected) return [];

    var form = getForm(root);
    var sellingPlan = getSellingPlanId(form);
    var items = [];

    var primary = {
      id: parseInt(selected.getAttribute("data-variant-id") || "0", 10),
      quantity: 1,
    };
    if (primary.id <= 0) return [];
    if (sellingPlan) primary.selling_plan = sellingPlan;
    items.push(primary);

    var addon = root.querySelector("[data-lp-ritual-addon]");
    if (
      addon &&
      addon.checked &&
      addon.getAttribute("data-available") !== "false"
    ) {
      var addonId = parseInt(addon.getAttribute("data-variant-id") || "0", 10);
      if (addonId > 0) {
        items.push({ id: addonId, quantity: 1 });
      }
    }

    return items;
  }

  // Shopify cart permalink: /cart/VARIANT:QTY or /cart/V1:1,V2:1
  function buildCartPermalink(root) {
    var items = buildItems(root);
    if (!items.length) return cartBase();

    var pairs = items
      .map(function (item) {
        return item.id + ":" + (item.quantity || 1);
      })
      .join(",");

    var url = cartBase() + "/" + pairs;
    var discountCode = root.getAttribute("data-discount-code") || "";
    if (discountCode) {
      url +=
        (url.indexOf("?") === -1 ? "?" : "&") +
        "discount=" +
        encodeURIComponent(discountCode);
    }
    return url;
  }

  function syncAtcLink(root) {
    var atc = root.querySelector("[data-lp-ritual-atc]");
    var selected = root.querySelector("[data-lp-ritual-variant]:checked");
    if (!atc) return;

    var permalink = buildCartPermalink(root);
    if (atc.tagName === "A") {
      atc.setAttribute("href", permalink);
    } else {
      atc.setAttribute("data-cart-permalink", permalink);
    }

    if (selected) {
      var variantId = selected.getAttribute("data-variant-id");
      if (variantId) atc.setAttribute("data-variant-id", variantId);
      var available = selected.getAttribute("data-available") !== "false";
      if (available) {
        atc.removeAttribute("aria-disabled");
        atc.removeAttribute("tabindex");
        if ("disabled" in atc) atc.disabled = false;
      } else {
        atc.setAttribute("aria-disabled", "true");
        atc.setAttribute("tabindex", "-1");
        if ("disabled" in atc) atc.disabled = true;
      }
    }
  }

  function syncVariantSelect(root) {
    var selected = root.querySelector("[data-lp-ritual-variant]:checked");
    var select =
      root.querySelector("[data-lp-ritual-variant-select]") ||
      root.querySelector("select.product-buy-buttons--select[name='id']") ||
      root.querySelector('select[name="id"]');
    if (!selected) return;

    var variantId = selected.getAttribute("data-variant-id");
    if (select && variantId) {
      select.value = variantId;
      select.dispatchEvent(new Event("change", { bubbles: true }));
    }

    try {
      document.dispatchEvent(
        new CustomEvent("variant:change", {
          detail: { variant: { id: parseInt(variantId, 10) } },
        }),
      );
      document.dispatchEvent(
        new CustomEvent("lp-ritual:variant-change", {
          bubbles: true,
          detail: {
            sectionId: root.getAttribute("data-section-id") || "",
            variantId: parseInt(variantId, 10),
            price: parseInt(selected.getAttribute("data-price") || "0", 10),
          },
        }),
      );
    } catch (e) {}

    root.querySelectorAll(".lp-editorial-ritual__pack").forEach(function (label) {
      var input = label.querySelector("[data-lp-ritual-variant]");
      label.classList.toggle("is-selected", !!(input && input.checked));
    });

    root.querySelectorAll(".lp-editorial-ritual__addon").forEach(function (label) {
      var input = label.querySelector("[data-lp-ritual-addon]");
      label.classList.toggle("is-selected", !!(input && input.checked));
    });

    syncAtcLink(root);
  }

  function handleAdd(button, root) {
    if (button.getAttribute("aria-busy") === "true") return;
    if (button.getAttribute("aria-disabled") === "true") return;

    var items = buildItems(root);
    if (!items.length) return;

    var discountCode = root.getAttribute("data-discount-code") || "";
    setBusy(button, true);

    var jobs = [addItems(items)];
    if (discountCode) jobs.push(applyDiscount(discountCode));

    Promise.all(jobs)
      .then(function (results) {
        openDrawer();
        setBusy(button, false);
        refreshCartInBackground(results[0]);
      })
      .catch(function (err) {
        setBusy(button, false);
        if (typeof console !== "undefined" && console.error) {
          console.error("lp editorial ritual buy failed", err);
        }
      });
  }

  // Use JS add when: selling plan selected, OR mini-cart enabled (same as hero).
  // Otherwise navigate via /cart/VARIANT:1 permalink.
  function shouldUseJsAdd(root) {
    if (getSellingPlanId(getForm(root))) return true;
    return isMiniCartEnabled();
  }

  function onClick(event) {
    var button =
      event.target && event.target.closest
        ? event.target.closest("[data-lp-ritual-atc]")
        : null;
    if (!button) return;

    var root = button.closest("[data-lp-ritual-builder]");
    if (!root) return;

    if (button.getAttribute("aria-disabled") === "true") {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    // Keep permalink current before decide.
    syncAtcLink(root);

    if (!shouldUseJsAdd(root)) {
      // One-time purchase, no mini-cart → follow /cart/id:1(,id:1) link.
      return;
    }

    // Mini-cart enabled: let lp-editorial-mini-cart.js handle <a href="/cart/...">
    // unless a selling plan is selected (permalink can't carry selling_plan).
    if (isMiniCartEnabled() && !getSellingPlanId(getForm(root))) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === "function") {
      event.stopImmediatePropagation();
    }
    handleAdd(button, root);
  }

  function onSubmit(event) {
    var form = event.target;
    if (
      !form ||
      !form.hasAttribute ||
      !form.hasAttribute("data-lp-ritual-form")
    )
      return;

    var root = form.querySelector("[data-lp-ritual-builder]");
    var button = form.querySelector("[data-lp-ritual-atc]");
    if (!root || !button) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === "function") {
      event.stopImmediatePropagation();
    }

    syncAtcLink(root);

    if (!shouldUseJsAdd(root)) {
      var href =
        button.getAttribute("href") ||
        button.getAttribute("data-cart-permalink") ||
        buildCartPermalink(root);
      window.location.href = href;
      return;
    }

    if (isMiniCartEnabled() && !getSellingPlanId(getForm(root))) {
      // Trigger the same path as clicking the cart permalink link.
      if (button.tagName === "A") {
        button.click();
      } else {
        handleAdd(button, root);
      }
      return;
    }

    handleAdd(button, root);
  }

  function onChange(event) {
    var target = event.target;
    if (!target) return;

    var root = target.closest("[data-lp-ritual-builder]");
    if (!root) return;

    if (target.hasAttribute("data-lp-ritual-variant")) {
      syncVariantSelect(root);
      return;
    }

    if (target.hasAttribute("data-lp-ritual-addon")) {
      var label = target.closest(".lp-editorial-ritual__addon");
      if (label) label.classList.toggle("is-selected", target.checked);
      syncAtcLink(root);
      return;
    }

    if (target.name === "selling_plan") {
      syncAtcLink(root);
    }
  }

  function initRoot(root) {
    if (!root || root.dataset.lpRitualBuilderReady === "true") return;
    root.dataset.lpRitualBuilderReady = "true";
    syncVariantSelect(root);
  }

  function initAll(scope) {
    (scope || document)
      .querySelectorAll("[data-lp-ritual-builder]")
      .forEach(initRoot);
  }

  document.addEventListener("click", onClick, true);
  document.addEventListener("submit", onSubmit, true);
  document.addEventListener("change", onChange, true);

  document.addEventListener(
    "AppstleSubscription:SubscriptionWidget:SubscriptionWidgetUpdated",
    function () {
      initAll(document);
    },
  );

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
